import React, { useMemo, useState } from 'react';
import { ItemList } from 'v2/models';
import MultiFilterDropdown from 'v2/form/CustomSelectors/Multiselect/MultiFilterDropdown';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

interface CustomSelectProps {
  onChange: (value: string[]) => void;
  options: string[];
  value: string[];
}

const CustomContainerSelect = ({
  options,
  onChange,
  value,
}: CustomSelectProps) => {
  const [selectedOptions, setSelectedOptions] =
    useState<readonly string[]>(value);

  const [viewAll, setViewAll] = useState(true);

  const optionList = useMemo(
    () => options.map((option, ix) => ({ name: option, id: ix })),
    [options]
  );

  const itemState = useMemo(
    () => ({
      list: optionList.filter((option) =>
        selectedOptions.includes(option.name)
      ),
      is_all: selectedOptions.length === options.length,
      view_all: viewAll,
    }),
    [options, selectedOptions, viewAll, optionList]
  );

  const optionState = useMemo(() => {
    if (itemState.view_all) {
      return optionList.map((option) => ({
        label: option.name,
        value: option,
      }));
    }
    return itemState.list.map((option) => ({
      label: option.name,
      value: option,
    }));
  }, [itemState, optionList]);

  const handleChange = (value: readonly string[] | string | null) => {
    setSelectedOptions((value as string[]) || []);
    onChange((value as string[]) || []);
  };

  const handleOptionChange = (
    value: ItemList | ((prev: ItemList) => ItemList)
  ) => {
    const localValue = typeof value === 'function' ? value(itemState) : value;

    setViewAll(localValue.view_all || false);
    if (localValue.is_all && !itemState.is_all) {
      handleChange(options);
      return;
    }
    if (!localValue.is_all && itemState.is_all) {
      handleChange([]);
      return;
    }
    handleChange(localValue.list.map((item) => item.name));
  };

  return (
    <div>
      <CurrentStateFilterContext.Provider
        value={{
          setCurrentState: handleOptionChange,
          currentState: itemState,
        }}
      >
        <MultiFilterDropdown
          id="allOptions"
          defaultOptions={optionState}
          loadOptions={(inputValue, callback) => {
            callback(
              optionState.filter((option) => option.label.includes(inputValue))
            );
          }}
          alternate={true}
        />
      </CurrentStateFilterContext.Provider>
    </div>
  );
};

export default CustomContainerSelect;
